/* Spark electrical tools - controller: state, live updates, shopping list, actions, hub search (sx-tools-ui.js) */
(() => {
'use strict';
const d = document, w = window, SX = w.SXT;
if (!SX || !SX.V) return;
const { T, money } = SX, V = SX.V;
const pcs = (n) => T(n === 1 ? 'item' : 'items', n >= 3 && n <= 10 ? 'قطع' : 'قطعة');
let uid = 0;
class Tool {
  constructor(root, def, cfg) {
    this.root = root; this.def = def; this.cfg = cfg || {}; this.k = root.getAttribute('data-sx-tool'); this.id = 'sxt' + (++uid);
    if (this.cfg.money) SX.mf = this.cfg.money;
    String(this.cfg.src || '').split(';').forEach((p) => { const a = p.split('='); if (a[0] && a[1]) SX.src[a[0].trim()] = a[1].trim(); });
    this.s = Object.assign(JSON.parse(JSON.stringify(def.init)), this.restore());
    this.sel = {}; this.qty = {}; this.off = {}; this.open = {}; this.cache = {}; this.items = []; this.r = {};
    root.innerHTML = '<div class="sx-qs" data-qs></div><div class="sx-res" data-res></div><p class="visually-hidden" aria-live="polite" data-say></p>';
    this.qs = root.querySelector('[data-qs]'); this.res = root.querySelector('[data-res]'); this.sayEl = root.querySelector('[data-say]');
    this.bar = d.createElement('div'); this.bar.className = 'sx-tbar'; d.body.appendChild(this.bar);
    if ('IntersectionObserver' in w) this.io = new IntersectionObserver((es) => { this.vis = es.some((e) => e.isIntersecting); this.barOn(); });
    this.bind(); this.renderQs(); this.update();
  }
  restore() {
    try { const q = new URLSearchParams(location.search).get('s'); if (q) return JSON.parse(decodeURIComponent(escape(atob(q.replace(/-/g, '+').replace(/_/g, '/'))))); } catch (e) {}
    try { return JSON.parse(localStorage.getItem('sxt:' + this.k) || '{}'); } catch (e) { return {}; }
  }
  link() {
    const b = btoa(unescape(encodeURIComponent(JSON.stringify(this.s)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const u = new URL(location.href); u.searchParams.set('s', b); return u.toString();
  }
  qList() { return (this.def.qs(this.s, this) || []).filter(Boolean); }
  sig(qs) { return qs.map((q) => q.id + ':' + (q.opts ? q.opts.map((o) => o.v).join(',') : '')).join('|'); }
  renderQs() {
    const qs = this.qList(), f = d.activeElement, inside = f && this.qs.contains(f), fq = inside && f.getAttribute('data-q'), fv = f && f.value, ft = f && f.type;
    this.qs.innerHTML = qs.map((q, i) => V.q(this, q, i)).join('');
    this.sg = this.sig(qs);
    if (fq) {
      const el = this.qs.querySelector(ft === 'radio' ? '[data-q="' + fq + '"][value="' + (w.CSS && CSS.escape ? CSS.escape(fv) : fv) + '"]' : '[data-q="' + fq + '"]');
      if (el) el.focus({ preventScroll: true });
    }
  }
  update() {
    let r = {};
    try { r = this.def.calc(this.s, this) || {}; } catch (e) { r = { ans: [], warn: T('Please check your answers.', 'راجع اختياراتك من فضلك.') }; }
    this.r = r; this.sel = {}; this.qty = {}; this.off = {}; this.open = {};
    (r.needs || []).forEach((n) => { if (n.opt) this.off[n.k] = true; });
    this.res.innerHTML = V.res(this, r);
    if (this.sayEl.textContent !== (r.say || '')) this.sayEl.textContent = r.say || '';
    if (this.io) { this.io.disconnect(); this.io.observe(this.res.querySelector('[data-shop]') || this.res); }
    this.resolve(r);
    try { localStorage.setItem('sxt:' + this.k, JSON.stringify(this.s)); } catch (e) {}
    clearTimeout(this.at);
    this.at = setTimeout(() => { try { if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sx_tool_result', { tool: this.k, result: r.say || '' }); } catch (e) {} }, 2500);
  }
  resolve(r) {
    const tok = (this.tok = (this.tok || 0) + 1), needs = r.needs || [];
    this.totals();
    needs.forEach((n) => {
      const key = n.src + '|' + n.sig;
      const pr = this.cache[key] || (this.cache[key] = SX.find(n.src, n.match).then((l) => { const seen = {}; return l.filter((c) => (seen[c.p.id] ? 0 : (seen[c.p.id] = 1))).slice(0, 6); }));
      pr.then((list) => { if (tok !== this.tok) return; n.list = list; this.refill(n.k); });
    });
  }
  pick(n) { return (n.list || []).find((x) => x.v.id === this.sel[n.k]) || (n.list || [])[0]; }
  q(n) { return this.qty[n.k] != null ? this.qty[n.k] : n.q; }
  refill(k) {
    const n = (this.r.needs || []).find((x) => x.k === k), el = this.res.querySelector('[data-need="' + k + '"]');
    if (n && el) { el.className = 'sx-it' + (this.off[k] ? ' is-off' : ''); el.innerHTML = V.item(this, n); }
    this.totals();
  }
  totals() {
    let sum = 0, cnt = 0; const items = [];
    (this.r.needs || []).forEach((n) => { const c = this.pick(n); if (this.off[n.k] || !c) return; V.lines(n, c, this.q(n)).forEach((l) => { sum += l.price * l.quantity; cnt += l.quantity; items.push({ id: l.id, quantity: l.quantity }); }); });
    this.items = items; this.sum = sum;
    const tot = this.res.querySelector('[data-total]'), add = this.res.querySelector('[data-act="add"]');
    if (tot) tot.innerHTML = items.length ? '<span>' + T('Total', 'الإجمالي') + ' <small>(' + cnt + ' ' + pcs(cnt) + ')</small></span><b>' + money(sum) + '</b>' : '';
    if (add) add.disabled = !items.length;
    this.bar.innerHTML = items.length ? '<div>' + T('Your list', 'قائمتك') + ' · ' + cnt + ' ' + pcs(cnt) + '<b>' + money(sum) + '</b></div><button type="button" class="sx-btn sx-btn--primary" data-act="add">' + SX.ico('cart') + T('Add all', 'أضف الكل') + '</button>' : '';
    this.barOn();
  }
  barOn() { this.bar.classList.toggle('is-on', !!(this.items.length && this.vis === false && this.moved)); }
  bind() {
    const R = this.root;
    R.addEventListener('change', (e) => {
      const t = e.target, q = t.getAttribute('data-q'), a = t.getAttribute('data-alt');
      if (q) this.set(q, t.type === 'number' || t.type === 'range' ? this.clamp(q, +t.value) : t.value, t.type === 'radio' || t.type === 'number');
      else if (a) { this.sel[a] = +t.value; this.refill(a); }
    });
    R.addEventListener('input', (e) => {
      const t = e.target, q = t.getAttribute('data-q');
      if (!q || (t.type !== 'range' && t.type !== 'number')) return;
      const def = this.qList().find((x) => x.id === q), o = t.type === 'range' && t.parentElement.querySelector('output');
      if (o && def) o.textContent = def.fmt ? def.fmt(+t.value) : t.value;
      if (t.value !== '') this.set(q, this.clamp(q, +t.value), false, 1);
    });
    const click = (e) => {
      const b = e.target.closest('button'); if (!b) return;
      const g = (n) => b.getAttribute(n);
      if (g('data-step')) { const q = g('data-q'), def = this.qList().find((x) => x.id === q); this.set(q, this.clamp(q, Math.round(((+this.s[q] || 0) + +g('data-step') * (def.inc || def.step || 1)) * 100) / 100), true); return; }
      if (g('data-li')) { const p = g('data-li').split(':'), def = this.qList().find((x) => x.id === p[0]), it = def.items.find((x) => x.k === p[1]), o = Object.assign({}, this.s[p[0]]); o[p[1]] = Math.max(0, Math.min(it.max || 20, (o[p[1]] || 0) + +g('data-d'))); this.set(p[0], o, true); return; }
      if (g('data-alts')) { const k = g('data-alts'); this.open[k] = !this.open[k]; this.refill(k); return; }
      if (g('data-off')) { const k = g('data-off'); this.off[k] = !this.off[k]; this.refill(k); return; }
      if (g('data-iq')) { const k = g('data-iq'), n = (this.r.needs || []).find((x) => x.k === k); this.qty[k] = Math.max(1, Math.min(99, this.q(n) + +g('data-d'))); this.refill(k); return; }
      if (g('data-act')) this.act(g('data-act'), b);
    };
    R.addEventListener('click', click); this.bar.addEventListener('click', click);
    w.addEventListener('scroll', () => { this.moved = 1; this.barOn(); }, { passive: true, once: true });
  }
  clamp(q, v) { const def = this.qList().find((x) => x.id === q) || {}; if (isNaN(v)) v = def.min || 0; return Math.min(def.max != null ? def.max : v, Math.max(def.min != null ? def.min : v, v)); }
  set(q, v, structural, live) {
    this.s[q] = v;
    if (this.def.on) this.def.on(q, this.s);
    if (structural || this.sig(this.qList()) !== this.sg) this.renderQs();
    clearTimeout(this.ut); this.ut = setTimeout(() => this.update(), live ? 180 : 0);
  }
  act(a, b) {
    const r = this.r || {};
    if (a === 'add') {
      if (!this.items.length) return;
      b.classList.add('is-loading');
      SX.cart(this.items).catch(() => SX.toast(T('Could not add to the cart — please try again.', 'تعذّرت الإضافة للسلة — حاول تاني.'), '', 1)).then(() => b.classList.remove('is-loading'));
    } else if (a === 'wa') w.open(this.wa(this.text()), '_blank', 'noopener');
    else if (a === 'share') {
      const u = this.link();
      if (navigator.share) navigator.share({ title: d.title, text: r.say || d.title, url: u }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(u).then(() => SX.toast(T('Link copied ✓', 'تم نسخ الرابط ✓')));
      else w.prompt('', u);
    } else if (a === 'print') w.print();
  }
  wa(text) { return 'https://wa.me/' + (this.cfg.wa || '201050008395') + '?text=' + encodeURIComponent(text); }
  text() {
    const r = this.r || {}, h1 = ((d.querySelector('.sx-tp h1') || {}).textContent || '').trim(), nl = String.fromCharCode(10);
    let t = T('Hello Spark, I used your tool "', 'أهلاً سبارك، استخدمت أداة "') + h1 + '":' + nl + (r.ans || []).map((a) => '• ' + a.l + ': ' + a.v + (a.c ? ' (' + a.c + ')' : '')).join(nl);
    (r.needs || []).forEach((n) => { const c = this.pick(n); if (this.off[n.k] || !c) return; t += nl + '- ' + c.name + (c.vt && !n.colors ? ' (' + c.vt + ')' : '') + ' × ' + this.q(n) + (n.colors ? ' ' + T('of each colour', 'من كل لون') + ' (' + n.colors.map((x) => x.l).join(T(', ', '، ')) + ')' : ''); });
    if (this.sum) t += nl + T('Total', 'الإجمالي') + ': ' + money(this.sum);
    return t + nl + this.link();
  }
}
SX.Tool = Tool;
function boot() {
  d.querySelectorAll('[data-sx-tool]').forEach((root) => {
    if (root.__sxt) return;
    const def = SX.defs[root.getAttribute('data-sx-tool')];
    if (!def) return;
    let cfg = {};
    try { cfg = JSON.parse(root.getAttribute('data-cfg') || '{}'); } catch (e) {}
    root.__sxt = new Tool(root, def, cfg);
  });
  d.querySelectorAll('[data-sx-hub-search]').forEach((inp) => {
    if (inp.__sxt) return; inp.__sxt = 1;
    const cards = d.querySelectorAll('.sx-hc'), empty = d.querySelector('.sx-hub__empty');
    inp.addEventListener('input', () => {
      const q = inp.value.trim().toLowerCase(); let n = 0;
      cards.forEach((c) => { const on = !q || (c.textContent + ' ' + (c.getAttribute('data-k') || '')).toLowerCase().indexOf(q) > -1; c.hidden = !on; if (on) n++; });
      d.querySelectorAll('.sx-hub__grid').forEach((g) => { const any = [].some.call(g.children, (c) => !c.hidden), h = g.previousElementSibling; g.style.display = any ? '' : 'none'; if (h && h.classList.contains('sx-hub__sec')) h.style.display = any ? '' : 'none'; });
      if (empty) empty.style.display = n ? 'none' : 'block';
    });
  });
}
/* deferred scripts: wait until every calculator file has registered */
SX.boot = boot;
if (d.readyState === 'complete') boot(); else d.addEventListener('DOMContentLoaded', boot);
d.addEventListener('shopify:section:load', boot);
})();